/**
 * Global
 * ------
 */
APP = {

    global: {

        init: function() {

            this.menuToggle();
            this.buttonHover();
            this.homepageContentHeight();
            this.productDescriptionExpand();
            this.lazyLoad();
            
        },

        menuToggle: function() {
            $('a.menu-toggle.main-dropdown').on('click', function(e) {
                e.preventDefault();
                $('#site-navigation').collapse('toggle');
            });

            $('a.menu-toggle.secondary-more').on('click', function(e) {
                e.preventDefault();
                $('.secondary-nav').collapse('toggle');
                

                if($(this).hasClass('opened')) {
                    $(this).removeClass('opened');
                    $(this).text('More');
                } else {
                    $(this).addClass('opened');
                    $(this).text('Less');
                }
            });

            $(document).ready(function() {
                var width = window.innerWidth || $(window).width();
                if(width >= 768 && width <= 1200) {
                    $('.secondary-nav').addClass('collapse');
                }
                if(width < 768) {
                    $('#site-navigation').addClass('collapse');
                } else {
                    $('#site-navigation').removeClass('collapse');
                }
            });
            $(window).resize(function() {
                var width = window.innerWidth || $(window).width();
                if(width > 1200) {
                    $('.secondary-nav').removeClass('collapse')
                }
                if(width >= 768 && width < 1200) {
                    $('.secondary-nav').addClass('collapse');
                }
                if(width < 768) {
                    $('#site-navigation').addClass('collapse');
                    $('.secondary-nav').removeClass('collapse');
                } else {
                    $('#site-navigation').removeClass('collapse');
                }
            });
            
        },

        buttonHover: function() {
            $('.btn.btn-clip').hover(
                function() {
                    $(this).removeClass('is-off').addClass('is-on');
                },
                function() {
                    $(this).removeClass('is-on').addClass('is-off');
                }
            );
        },
     
        homepageContentHeight: function() {
            var image = $('.homepage .homepage-content .image'),
                content = $('.homepage .homepage-content');

            $(document).ready(function() {
                var width = window.innerWidth || $(window).width();
                if(width >= 992) {
                    image.imagesLoaded(function() {
                        content.height(image.height());
                    });                    
                }
            });

            $(window).resize(function() {
                var width = window.innerWidth || $(window).width();
                if(width >= 992) {
                    image.imagesLoaded(function() {
                        content.height(image.height());
                    });
                } else {
                    content.height('');
                }
            });
        },

        productDescriptionExpand: function() {
            var $toggleButtons = $('.toggle-description');

			$toggleButtons.each(function () {
				$(this).on('click', function (e) {
                    e.preventDefault();

                    var target = $(this).data('target');
                    $('#'+target).collapse('toggle');
                    $(this).toggleClass('collapsed');

                    if($(this).hasClass('collapsed')) {
                        $(this).html('More Info');
                    } else {
                        $(this).html('Less Info');
                    }
				});
			});

        },

        lazyLoad: function() {
            $(window).on('load', function() {
                $('.lazy-load').each(function () {
                    if (isInViewport($(this))) {
                        src = $(this).data('src');
                        $(this).attr('src', src);
                        $(this).removeClass('lazy-load');
                    }
                })
            });
            $(window).on('resize scroll', function() {
                $('.lazy-load').each(function () {
                    if (isInViewport($(this))) {
                        src = $(this).data('src');
                        $(this).attr('src', src);
                        $(this).removeClass('lazy-load');
                    }
                })
            });
            function isInViewport(element) {
                var elementTop = $(element).offset().top;
                var elementBottom = elementTop + $(element).outerHeight();
                var viewportTop = $(window).scrollTop();
                var viewportBottom = viewportTop + $(window).height();

                return elementBottom > viewportTop && elementTop < viewportBottom;
            }
        },

    }

};

UTIL = {

    fire : function(func, funcname, args){

        var namespace = APP;

        funcname = (funcname === undefined) ? 'init' : funcname;
        if (func !== '' && namespace[func] && typeof namespace[func][funcname] == 'function'){
            namespace[func][funcname](args);
        }

    },

    loadEvents : function($){

        var bodyId = document.body.id;

        // hit up common first.
        UTIL.fire('global');

        // do all the classes too.
        $.each(document.body.className.replace(/-/g, '_').split(/\s+/),function(i,classnm) {
            UTIL.fire(classnm);
            UTIL.fire(classnm,bodyId);
        });

    }
};

(function($) {
    // kick it all off here
    UTIL.loadEvents($);
})( jQuery );